import React, { FunctionComponent } from 'react'
import { BASE_PATH } from '../../env'
import styles from './style.module.css'
import Image from 'next/image'
import { Theme, useGetSelectedTheme, useIsDarkMode } from '@afterpaytouch/core'

interface ColorSchemeImage {
  dark: string
  light: string
}
type ArcadeThemes = Exclude<Theme, Theme.AP>
type ArcadeSrc = Record<ArcadeThemes, ColorSchemeImage>

export const BiometricAnimation: FunctionComponent = () => {
  const isDarkMode = useIsDarkMode()
  const theme = useGetSelectedTheme()

  const eyeGreenSvgSrcLight = [BASE_PATH, 'images/biometric/eye-recognition-green-light.svg'].join('/')
  const eyeGreenSvgSrcDark = [BASE_PATH, 'images/biometric/eye-recognition-green-dark.svg'].join('/')
  const eyeMintSvgSrcLight = [BASE_PATH, 'images/biometric/eye-recognition-mint-light.svg'].join('/')
  const eyeMintSvgSrcDark = [BASE_PATH, 'images/biometric/eye-recognition-mint-dark.svg'].join('/')

  const faceSvgSrc = [BASE_PATH, 'images/biometric/face.svg'].join('/')
  const fingerprintSvgSrc = [BASE_PATH, 'images/biometric/fingerprint.svg'].join('/')
  const tickSvgSrc = [BASE_PATH, 'images/biometric/tick.svg'].join('/')

  const arcadeSrcMap: ArcadeSrc = {
    [Theme.Pegasus]: {
      dark: eyeGreenSvgSrcDark,
      light: eyeGreenSvgSrcLight,
    },
    [Theme.Cash]: {
      dark: eyeGreenSvgSrcLight, // The Cash theme (Unicorn) does not support dark mode
      light: eyeGreenSvgSrcLight,
    },
    [Theme.Kelpie]: {
      dark: eyeMintSvgSrcDark,
      light: eyeMintSvgSrcLight,
    },
  }

  if (theme !== Theme.AP) {
    const colorScheme = isDarkMode ? 'dark' : 'light'
    const eyeSvgSrc = arcadeSrcMap[theme][colorScheme]

    return (
      <Image
        src={eyeSvgSrc}
        alt='eye-id'
        width='249'
        height='119'
        style={{
          maxWidth: '100%',
          height: 'auto',
        }}
      />
    )
  }

  return (
    <div className={styles.animation}>
      <div className={styles.face}>
        <Image
          src={faceSvgSrc}
          alt='face-id'
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.fingerprint}>
        <Image
          src={fingerprintSvgSrc}
          alt='fingerprint'
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
      <div className={styles.tick}>
        <Image
          src={tickSvgSrc}
          alt=''
          width='75'
          height='75'
          style={{
            maxWidth: '100%',
            height: 'auto',
          }}
        />
      </div>
    </div>
  )
}
